function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 35H35V0H0V35Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2729 10H19.4547C19.053 10 18.7274 10.3256 18.7274 10.7273C18.7274 11.1289 19.053 11.4546 19.4547 11.4546H23.5171L16.0314 18.9403C15.7474 19.2243 15.7474 19.6848 16.0314 19.9688C16.1734 20.1108 16.3595 20.1818 16.5456 20.1818C16.7317 20.1818 16.9179 20.1108 17.0599 19.9688L24.5456 12.4831V16.5455C24.5456 16.9471 24.8713 17.2727 25.2729 17.2727C25.6746 17.2727 26.0002 16.9471 26.0002 16.5455V10.7273C26.0002 10.3256 25.6745 10 25.2729 10Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3636 17.2727C21.962 17.2727 21.6363 17.5984 21.6363 18V24.5455H11.4545V14.3636H18C18.4017 14.3636 18.7273 14.038 18.7273 13.6364C18.7273 13.2347 18.4017 12.9091 18 12.9091H10.7273C10.3256 12.9091 10 13.2347 10 13.6364V25.2728C10 25.6744 10.3256 26 10.7273 26H22.3637C22.7653 26 23.0909 25.6744 23.0909 25.2727V18C23.0909 17.5984 22.7653 17.2727 22.3636 17.2727Z",
  fill: "black"
});

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.b74556b9.svg";
export { ForwardRef as ReactComponent };